import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';
import { BetslipV1Pick } from '../../core/picks/betslip-v1-pick';
import { IPlacedBetslipResult } from '../betplacement/models';
import { BetslipError } from '../validation/errors/betslip-error';
import { IFinishPlaceTeaserBets } from './models';

export interface IAddTeaserPickPayload {
    pick: BetslipV1Pick;
    selectedOption: EventOption;
    alternateOptions: { [optionId: number]: EventOption };
    alternatePicks?: { [pickId: string]: BetslipV1Pick };
    isSelected?: boolean;
}

export interface ITeasePicksPayload {
    sportId: number;
    keypoint: number;
    teasedOptions: { [pickId: string]: EventOption };
}

export interface IAddTeaserAlternatePickPayload {
    sportId: number;
    alternatePick: { pickId: string; optionId: number; pick: BetslipV1Pick };
}

export class BetslipTeaserBetPlaceBetActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/teaser/placebet`;

    private static readonly PLACE_BET = `${BetslipTeaserBetPlaceBetActions.ACTION_SCHEMA}/PLACE_BET`;
    private static readonly FINISH_PLACING_TEASERBETS = `${BetslipTeaserBetPlaceBetActions.ACTION_SCHEMA}/FINISH_PLACING_TEASERBETS`;
    private static readonly PLACE_TEASERBETS_DONE = `${BetslipTeaserBetPlaceBetActions.ACTION_SCHEMA}/PLACE_TEASERBETS_DONE`;
    private static readonly PLACE_TEASERBETS_SUCCEEDED = `${BetslipTeaserBetPlaceBetActions.ACTION_SCHEMA}/PLACE_TEASERBETS_SUCCEEDED`;
    private static readonly PLACE_BET_FAIL = `${BetslipTeaserBetPlaceBetActions.ACTION_SCHEMA}/PLACE_BET_FAILED`;
    private static readonly CLEAR_RESULTS = `${BetslipTeaserBetPlaceBetActions.ACTION_SCHEMA}/CLEAR_RESULTS`;

    /* Finish placing teaser bets request */
    static finishPlaceBets = createAction(BetslipTeaserBetPlaceBetActions.FINISH_PLACING_TEASERBETS, props<{ payload: IFinishPlaceTeaserBets }>());

    static placeBetDone = createAction(BetslipTeaserBetPlaceBetActions.PLACE_TEASERBETS_DONE, props<{ payload: IPlacedBetslipResult[] }>());

    static placeBetSucceeded = createAction(BetslipTeaserBetPlaceBetActions.PLACE_TEASERBETS_SUCCEEDED);

    static placeBet = createAction(BetslipTeaserBetPlaceBetActions.PLACE_BET);

    static placeBetFailed = createAction(BetslipTeaserBetPlaceBetActions.PLACE_BET_FAIL);

    static placeBetResponseErrors = createAction(
        BetslipTeaserBetPlaceBetActions.PLACE_BET_FAIL,
        props<{ pickErrors: {}; betslipErrors: BetslipError[] }>(),
    );

    /* clear teaserbet placement result*/
    static clearResults = createAction(BetslipTeaserBetPlaceBetActions.CLEAR_RESULTS);
}
